import React from 'react';

export interface TagFilterContainerProps {
    tabs: string[];
    onChange: (key: string) => void;
    activeTab: string;
    displayMap?: Map<string, React.ReactNode>;
}

export const TagFilterContainer = (props: TagFilterContainerProps) => {
    return (
        <ul className='bg-background-surface outline-border-default flex flex-wrap items-center justify-start gap-8 self-stretch rounded-xl p-6 outline-1 outline-offset-[-1px]'>
            {props.tabs.map((key) => (
                <li
                    key={key}
                    onClick={() => {
                        props.onChange(key);
                    }}
                    className={`cursor-pointer justify-start ${key.toLowerCase() === props.activeTab.toLowerCase() ? 'text-brand-primary' : 'text-brand-muted hover:text-foreground-default'} text-lg font-semibold`}>
                    {props.displayMap?.get(key) ?? key.charAt(0).toUpperCase() + key.slice(1)}
                </li>
            ))}
        </ul>
    );
};
